import React, { useCallback, useMemo } from "react";
import classNames from "classnames";
import TextTruncate from "components/TextTruncate";
import { getPointColor } from "rs-components/Spaceviewer/utils";
import { renderNumberValue } from "utils/string";
import { SpaceviewerAxisType } from "shared/types";
import { N_A } from "shared/rsDictionary";
import { isNotEmpty } from "utils/validate";
import * as styles from "../legend-styles.module.scss";
const OptimizationPreviewLegend = ({ legendData, error, selectedPoint, parameters, slidersValues, insightError, }) => {
    const { data: { response: { value } = {}, values } = {} } = selectedPoint ?? {};
    const newInsightValue = useMemo(() => {
        if (insightError) {
            return N_A;
        }
        else {
            return error ? "Error" : value && renderNumberValue(value);
        }
    }, [error, insightError, value]);
    const tdValue = useMemo(() => isNotEmpty(value) && (value ?? 0) < 60, [value]);
    const colorError = useMemo(() => error && !insightError, [error, insightError]);
    const getNewValue = useCallback((index, parameterType) => {
        if (error || insightError) {
            return null;
        }
        const rawValue = values === undefined ? slidersValues?.[index] : values?.[index];
        return parameterType === SpaceviewerAxisType.FLOAT
            ? renderNumberValue(rawValue)
            : parameters[index]?.steps[rawValue]?.label;
    }, [error, insightError, parameters, slidersValues, values]);
    return (React.createElement("div", { className: styles["legend-table"] },
        React.createElement("table", null,
            React.createElement("colgroup", null,
                React.createElement("col", { className: styles["table-parameter"] })),
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Parameter"),
                    React.createElement("th", null, "Old"),
                    React.createElement("th", null, "New"))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Insight value"),
                    React.createElement("td", null, typeof legendData.insight === "number"
                        ? renderNumberValue(legendData.insight)
                        : legendData.insight),
                    React.createElement("td", { className: classNames(styles["insight-value"], {
                            [styles["tdError"]]: colorError,
                            [styles["insight-value-inverted"]]: tdValue,
                        }), style: value === undefined ? {} : { backgroundColor: getPointColor(value ?? N_A) } }, newInsightValue)),
                (parameters || []).map(({ id, name, sourceId, type, inputId, simulationName }, index) => {
                    const oldParameter = legendData.parameters?.find((parameter) => `${parameter?.type === SpaceviewerAxisType.FLOAT ? parameter?.parameterId : parameter?.stepId}` === `${id}` &&
                        sourceId === parameter?.sourceId &&
                        inputId === parameter?.inputId);
                    return (React.createElement("tr", { key: `${id}-${name}-${index}` },
                        React.createElement("td", null,
                            React.createElement(TextTruncate, { title: simulationName, className: styles["table-parameter-name"], text: name })),
                        React.createElement("td", null, typeof oldParameter?.value === "number"
                            ? renderNumberValue(oldParameter?.value)
                            : oldParameter?.value),
                        React.createElement("td", null, getNewValue(index, type))));
                })))));
};
export default OptimizationPreviewLegend;
